<template>
  <div ref="accountApiCard" class="api-key-card-main">
    <h1>
      API KEY
    </h1>
    <p>Your reSolved API key</p>
    <h2>{{ apiKey }}</h2>
    <ButtonFilled @onButtonClicked="handleApiUpdate" text="Generate New Key"></ButtonFilled>
  </div>
</template>

<script>
import ButtonFilled from "../../../common/ButtonFilled";
import {handleUpdateApiKey} from "../../../../service/user"
export default {
  components: {
    ButtonFilled,
  },
  computed: {
    apiKey() {
      return this.$store.getters["userStore/getApiKey"];
    },
  },
  async mounted() {
    await this.sleep(10);
    this.$refs.accountApiCard.style = "transform: scale(1) !important";
  },
  methods: {
    handleApiUpdate(){
      handleUpdateApiKey()
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style>
.api-key-card-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 275px;
  max-width: 30%;
  height: 265px;
  width: 30%;
  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}

.api-key-card-main > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans-SemiBold";
}

.api-key-card-main > p {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans-SemiBold";
  margin-top: 4px;
}

.api-key-card-main > h2 {
  font-size: 18px;
  margin-top: 43px;
  color: #ffffff;
  margin-bottom: 55px;
  word-break: break-all;
}
</style>
